import { RouteComponentProps } from '@reach/router';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';

import FolxHeader from '@ui/molecules/FolxHeader';

import PageContainer from '@ui/organisms/PageContainer';

import Footer from '@components/WSFooter';

import { getThemeForFlow } from '@theme/FlowThemes';
import theme from '@theme/FolxTheme';

interface DashboardRouteProps extends RouteComponentProps {
	path?: string;
	children?: ReactNode;
}

export const StyledPageContainer = styled(PageContainer)<{ showGradient?: boolean }>`
	min-height: 100vh;
`;

export const ErrorContainer = styled.div`
	align-items: center;
	/* background: ${theme.colors.white}; */
	display: flex;
	flex-flow: column;
	padding-top: ${theme.spacing.md};
	padding-bottom: ${theme.spacing.xxxl};
	padding-left: ${theme.spacing.md};
	padding-right: ${theme.spacing.md};
	min-height: 100%;
	width: 100%;
	max-width: 68rem;

	@media ${theme.responsive.breakpoints.tablet} {
		padding-left: 0;
		padding-right: 0;
	}
`;

const ErrorRoute: FC<DashboardRouteProps> = ({ children }) => {
	return (
		<ThemeProvider theme={getThemeForFlow('dashboard')}>
			<StyledPageContainer header={<FolxHeader />} footer={<Footer />}>
				<ErrorContainer>{children}</ErrorContainer>
			</StyledPageContainer>
		</ThemeProvider>
	);
};

export default ErrorRoute;
